<template>
  <div>
    <div v-if="!isSuccess" class="login-warp" :style="'min-height:' + clientHeight">
      <div class="logo">
        <img src="../../assets/imgs/logo.png" alt="" />
      </div>
      <div class="login-row">
        <div class="area" @click="isAreaView = true">
          <span>+{{ areaCode }}</span>
          <div class="area-down"></div>
        </div>
        <input
          type="number"
          v-model="phone"
          :placeholder="i18n.phone_number.format(weishu)"
        />
      </div>
      <div class="login-row">
        <input type="text" v-model="inviteCode" :placeholder="i18n.couponcode" />
      </div>
      <div v-if="verifyCodeShow" class="login-row">
        <input type="number" v-model="code" :placeholder="i18n.captcha_code" />
        <div class="login-code" @click="onCaptcha">
          <img :src="captchaUrl" />
        </div>
      </div>
      <div class="btn" @click="onSendCode">{{ i18n.submit }}</div>
      <select-area v-model="isAreaView" @select="onSelct"></select-area>
      <login-code
        v-if="isLoginCode"
        :confrimtext="i18n.submit"
        @submit="onLogin"
        @again="onBack"
        @back="onBack"
      ></login-code>
    </div>
    <div v-else class="dhsuccess">
      <img src="../../assets/imgs/success.png" alt="">
      <p>{{ i18n.exchangesuccess }}</p>
    </div>
  </div>
</template>

<script>
import { SelectArea } from '../../components/select'
import { generateUUID } from '../../utils/index'
import { baseURL } from '../../utils/http'
import {
  CHECK_MYLINKUSER,
  REDEEM_INVITECODE,
  USER_CAPTCHA,
  SEND_CODE
} from '../../apis/user'
import { LoginCode } from '../../components/login'
import { mapState } from 'vuex'
export default {
  components: {
    SelectArea,
    LoginCode
  },
  computed: {
    ...mapState(['user', 'browser', 'lang']),
    i18n () {
      return this.$t('login')
    },
    weishu () {
      return this.areaCode === '86' ? 11 : 8
    },
    verifyCodeShow () {
      return this.phone !== this.myLinkMobile || !this.thirdPartyToken
    }
  },
  watch: {
  },
  data () {
    return {
      isAreaView: false,
      areaCode: '852',
      phone: '',
      myLinkMobile: '',
      thirdPartyToken: '',
      code: '',
      captchaUrl: '',
      uuid: '',
      isLoginCode: false,
      isSuccess: false,
      clientHeight: '800px',
      // ui: null
      inviteCode: ''
    }
  },
  methods: {
    onSelct (val) {
      this.areaCode = val
    },
    onCaptcha () {
      this.code = ''
      this.uuid = generateUUID()
      this.captchaUrl = `${baseURL}${USER_CAPTCHA}?uuid=${this.uuid}`
    },
    onLogin (code) {
      this.$loading(true)
      let url = REDEEM_INVITECODE
      let param = {
        mobile: this.areaCode + this.phone,
        areaCode: this.areaCode,
        // verifyCode: code,
        inviteCode: this.inviteCode
      }
      if (this.verifyCodeShow && code) {
        param.verifyCode = code
      }
      if (this.thirdPartyToken) {
        param.myLinkToken = this.thirdPartyToken
      }
      // console.log(url, param)
      this.$post(
        url,
        param,
        res => {
          console.log(res)
          this.$loading(false)
          if (res.data && res.data.token) {
            this.isSuccess = true
          } else {
            this.$toast(this.i18n.msg)
          }
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onSendCode () {
      if (!this.phone.trim()) {
        this.$toast(this.i18n.phone_number.format(this.weishu))
        return
      }
      if (!this.inviteCode.trim()) {
        this.$toast(this.i18n.couponcode)
        return
      }
      if (!this.verifyCodeShow) {
        this.onLogin()
        console.log('不用验证码')
        return
      }
      console.log('要验证码')
      this.$loading(true)
      this.$post(
        SEND_CODE,
        {
          mobile: this.areaCode + this.phone,
          uuid: this.uuid,
          code: this.code
        },
        res => {
          console.log(res)
          this.$loading(false)
          this.isLoginCode = true
        },
        err => {
          console.log(err)
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    onBack () {
      this.isLoginCode = false
      this.onCaptcha()
    },
    loadUser () {
      this.$loading(true)
      this.$get(
        CHECK_MYLINKUSER,
        {
          myLinkToken: this.thirdPartyToken
        },
        res => {
          this.$loading(false)
          console.log('mylinkuser===', res)
          if (res && res.data && res.data.mobile) {
            this.myLinkMobile = res.data.mobile
            this.phone = res.data.mobile
          }
          if (res && res.data && res.data.areaCode) {
            this.areaCode = res.data.areaCode
          }
        },
        err => {
          this.$loading(false)
          this.$confirm({
            title: this.i18n.msg_fail_title,
            content: err,
            showCancel: false
          })
        }
      )
    },
    onTermsService () {
      window.open('https://app.easycharge.com.hk/content/user_agreement.html')
    },
    onPrivacyPolicy () {
      window.open('https://app.easycharge.com.hk/content/privacy_policy.html')
    }
  },
  created () {
    console.log('url==', window.location.href)
    console.log('query==', this.$route.query)
    this.thirdPartyToken = this.$route.query.thirdPartyToken
    if (this.thirdPartyToken) {
      this.loadUser()
    }
  },
  mounted () {
    this.onCaptcha()
    this.clientHeight = document.body.clientHeight + 'px'
  }
}
</script>

<style lang="less">
.login-warp {
  min-height: 100vh;
  background-color: #fff;
  position: relative;
  .logo {
    padding-top: 60px;
    img {
      // width: 300px;
      // height: 300px;
      border-radius: 20px;
      display: block;
      margin: 0 auto;
    }
  }
  .login-row {
    margin: 36px 96px;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 4px solid #000;
    .area {
      width: 100px;
      padding: 0 10px;
      display: flex;
      justify-content: space-around;
      align-items: center;
    }
    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }
    .area-down {
      // margin-left: 10px;
      width: 0;
      height: 0;
      border-width: 10px 10px 0;
      border-style: solid;
      border-color: black transparent transparent;
    }
    .login-code {
      width: 180px;
      height: 60px;
      background-image: linear-gradient(
        to right,
        rgba(194, 194, 194, 1),
        rgba(252, 252, 252, 1)
      );
      img {
        width: 180px;
        height: 60px;
      }
    }
  }
  .btn {
    margin: 60px 96px 0;
  }
  .login-foot {
    // position: absolute;
    // left: 96px;
    // right: 96px;
    // bottom: 48px;
    padding: 20px;
    &-tips {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      margin: 0 60px;
      span {
        z-index: 100;
        background: #fff;
        padding: 28px;
      }
      &::after {
        position: absolute;
        content: " ";
        height: 1px;
        width: 100%;
        background-color: #000;
        z-index: 99;
      }
    }
    &-imgs {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background-color: #e4e7ed;
        margin: 0 24px;
      }
    }
  }
  .login-info {
    font-size: 24px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 33px;
    display: flex;
    justify-content: flex-start;
    padding: 0 96px;
  }
  .login-info .readme {
    font-weight: 500;
    color: rgba(52, 125, 255, 1);
    margin-left: 10px;
    display: inline;
  }
  .firebaseui-idp-list {
    display: flex;
    justify-content: center;
    .firebaseui-list-item {
      margin: 20px;
      .firebaseui-idp-button {
        min-width: 20px;
        min-height: 20px;
        height: auto;
        width: auto;
        padding: 16px;
        border-radius: 50%;
        .firebaseui-idp-text.firebaseui-idp-text-long {
          display: none;
        }
      }
    }
  }
  .login-text {
    color: #757575;
    font-size: 24px;
    text-align: center;
    padding: 76px;
    span {
      color: #4285f4;
    }
  }
}
.dhsuccess{
  img{
    display: block;
    margin: 150px auto 0;
  }
  p{
    text-align: center;
    font-size: large;
  }
}
</style>
